import filterDrawer from '@/lib/collection/filter-drawer';

const filtering = (filterForm, container) => {
  const drawer = filterDrawer(container);
  let formData, searchParams;

  setParams();

  function setParams() {
    formData = new FormData(filterForm);
    searchParams = new URLSearchParams(formData).toString();
  }

  return {
    getState() {
      return {
        url: searchParams,
      };
    },

    filtersUpdated(cb) {
      setParams();
      return cb(this.getState());
    },

    removeFilters(target, cb) {
      drawer.removeFilter(target);
      setParams();

      return cb(this.getState());
    },

    removeRange(cb) {
      drawer.removeRange();
      setParams();

      return cb(this.getState());
    },

    clearAll(cb) {
      searchParams = '';
      drawer.clearAll();

      return cb(this.getState());
    },

    unload() {
      drawer();
    },
  };
};

export default filtering;
